<template>
  <div class="pre-info">
    <el-form-item label="计价策略:" :label-width="Width">
      <el-select filterable  v-model="data.strategyId" placeholder="请选择计价策略">
        <el-option
          v-on:click.native="handleStr(item)"
          v-for="(item, $index) in data.strategy"
          :key="$index"
          :label="item.strategyName"
          :value="item.strategyId">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="计价规则:" :label-width="Width">
      <el-input style="width: 217px;" maxlength="60" clearable v-model="data.ruleNameCn" ></el-input>
      <!-- <el-select filterable  v-model=""  placeholder="请选择计价规则">
        <el-option
          v-for="(item, $index) in data.rule"
          :key="$index"
          :label="item.ruleNameCn"
          :value="item.ruleId" v-on:click.native="handleRule(item)" >
        </el-option>
      </el-select> -->
    </el-form-item>
    <!-- <el-form-item label="计费字段:" :label-width="Width" v-for="(item, $index) in data.billArr" :key="$index">
      <el-input style="width: 217px;" maxlength="32" :disabled="data.disabled" v-model="item.billKeyWord"></el-input>
      <el-input style="width: 217px;" maxlength="32" :disabled="data.disabled" class="ml" v-model="item.billParamName"></el-input>
    </el-form-item> -->
  </div>
</template>
<style>
.ul li {
  list-style: none;
}
.add-info {
  position: absolute;
  top: 0px;
  left: 350px;
}
.info-title {
  font-weight: bolder;
}
.pre-info {
  position: relative;
}
.ml {
  margin-left: 10px;
}
</style>
<script>
export default {
  props: ['data', 'strategy'],
  data () {
    return {
      value14: '',
      Width: '120px'
    }
  },
  methods: {
    handleStr (item) {
      this.$emit('getRule', item)
    },
    handleRule (item) {
      this.$emit('getBill', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/proManage/rule/index.vue